import * as log from "loglevel";
import { ACTIONS } from "UTILS/Constants";
import { socketMessage, webRtcMessageId} from "WEBSOCKET/constants";
log.setLevel("info");

export const handleMessage = (data, store) => {
  switch (data.action) {
    case socketMessage.subCategories.ERROR._ERROR:
      switch (data.code) {
        case webRtcMessageId.KMS_NOT_CONNECTED:
          store.dispatch({
            type: ACTIONS.ERROR.KMS_NOT_CONNECTED,
            value: false
          });
          break;
        case webRtcMessageId.ERROR_IN_WEBRTC_MEDIA_SHARING:
          store.dispatch({
            type: ACTIONS.ERROR.ERROR_IN_WEBRTC_MEDIA_SHARING
          });
          store.dispatch({
            type: ACTIONS.RESET_SHOW_KMS_CONNECTION_STATUS
          });
          store.dispatch({
            type: ACTIONS.SET_SNAPSHOT_PERMISSION_REPLY,
            snapshotPermissionReply: null
          });
          store.dispatch({
            type: ACTIONS.SET_SNAPSHOTER_ID,
            snapshoterId: ""
          });
          store.dispatch({
            type: ACTIONS.SET_SNAPSHOTEE_ID,
            snapshoteeId: ""
          });
          if (store.getState().ParticipantReducer.participants.length < 3) {
            store.dispatch({
              type: ACTIONS.SNAPSHOT.SHOW_SNAPSHOT,
              value: false
            });
          }
          break;
        default:
          // console.log("data :", data);
          break;
      }
      break;
  }
};
